/**
 * Material-style filled icons sourced from Figma. One wrapper per glyph
 * sharing the inline-SVG injection pattern from `predictor-brand-icon.tsx`
 * and `close-icon.tsx`.
 *
 * If you re-export any of these from Figma, edit the source SVG to use
 * `width="100%" height="100%"` and `fill="currentColor"` — we don't
 * normalize at runtime. Color is driven by the parent's `text-*` class.
 */

import type { JSX } from "preact";
import rawArrowOutward from "../assets/images/arrow-outward.svg";
import rawCheck from "../assets/images/check.svg";
import rawChevronDown from "../assets/images/chevron-down.svg";
import rawInfo from "../assets/images/info.svg";
import rawSchedule from "../assets/images/schedule.svg";
import rawTrendingDown from "../assets/images/trending-down.svg";
import rawTrendingUp from "../assets/images/trending-up.svg";

interface IconProps {
  className?: string;
}

function inlineIcon(svg: string, className?: string): JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={className}
      // eslint-disable-next-line react/no-danger -- inlined bundled asset, no user input
      dangerouslySetInnerHTML={{ __html: svg }}
      style={{ display: "block", lineHeight: 0 }}
    />
  );
}

export function ArrowOutwardIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawArrowOutward, className);
}

export function CheckIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawCheck, className);
}

export function ChevronDownIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawChevronDown, className);
}

export function InfoIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawInfo, className);
}

export function ScheduleIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawSchedule, className);
}

export function TrendingDownIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawTrendingDown, className);
}

export function TrendingUpIcon({ className }: IconProps): JSX.Element {
  return inlineIcon(rawTrendingUp, className);
}
